import { stats } from '@/mocks/home';

export default function StatsSection() {
  return (
    <section className="w-full bg-background-50 pb-14 md:pb-20">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <div className="reveal grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 lg:grid-cols-4">
          {stats.map((item) => (
            <div key={item.label} className="bg-background-50 px-5 py-6 md:px-7 md:py-8">
              <p className="font-heading text-2xl font-bold text-foreground-950 md:text-[32px]">
                {item.value}
              </p>
              <p className="mt-2 font-label text-[13px] font-medium text-primary-600">
                {item.label}
              </p>
              <p className="mt-1 font-body text-[12px] leading-relaxed text-foreground-500">
                {item.note}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}